{
  "$schema": "./worlds-metadata.schema.json",
  "version": "2.1.0",
  "generated_at": "2026-05-28",
  "source": "Generated by scripts/audit-worlds-metadata.sh : audit live SSM via container rmf-demo-rmf_core-1 du building.yaml + fleet_config.yaml upstream rmf_demos. A re-generer apres chaque bump image upstream-mirror/rmf_demos.",
  "schema_notes": {
    "worlds.<name>.waypoints.<waypoint_name>": "Chaque waypoint a level (L1/L2/L3), x/y en pixels building.yaml (a multiplier par scale du level pour metres), et flags semantic optionnels (is_charger, is_cleaning_zone, is_holding_point, is_parking_spot, pickup_dispenser, dropoff_ingestor, spawn_robot_name, spawn_robot_type).",
    "waypoint x/y unit": "Pixels image (cf level.drawing.scale dans hotel.building.yaml upstream). Pour metres ROS : multiplier par scale (~0.0557 m/pixel pour hotel, varie par world).",
    "worlds.<name>.fleets.<name>.actions": "Categories de dispatch supportees par cette fleet : patrol, delivery, clean. Pour clean, utiliser le format compose (cf rmf-task-dispatch.md).",
    "worlds.<name>.fleets.<name>.robots": "Mapping robot_name -> {charger: waypoint_name}. Chaque robot a SON charger specifique.",
    "worlds.<name>.fleets.<name>.action_paths": "Dict des actions disponibles -> liste des zones/places supportees (ex: {clean: [clean_lobby, clean_restaurant, clean_waiting_area]}).",
    "worlds.<name>.fleets.<name>.task_capabilities": "Dict {loop: bool, delivery: bool} pour les capabilities standard rmf_demos.",
    "dispatch_examples": "Payloads complets prets a copier pour patrol, delivery, et clean (format compose officiel upstream).",
    "audit_lane_pending": "True signale que la liste des waypoints peut contenir des vertex visuels non-navigables (presents dans building.yaml mais sans lane qui les connecte au nav_graph). Sera mis a False au prochain audit complet qui captera lane_graph_indices par waypoint. En attendant, le frontend doit tolerer un rejet fleet_adapter \"waypoint not in navigation graph\" sur certains waypoints listes ici.",
    "lane_graph_indices": "Liste des indices de graphs (= fleets routing) auxquels ce waypoint est connecte via au moins une lane. Liste vide [] = vertex visuel/holding only, NON dispatchable (le fleet_adapter rejette avec 'waypoint not in navigation graph'). Le frontend doit filtrer sur lane_graph_indices.length > 0 pour les UI de selection dispatch. Audit complet en V2.1.0 (tous worlds, tous waypoints).",
    "worlds.<name>.fleets.<name>.lane_graph_indices": "Liste agregee des graph_indices auxquels au moins un robot de cette fleet est connecte (via son charger). Permet au frontend de pre-filtrer les waypoints atteignables par cette fleet (intersection avec waypoints.<wp>.lane_graph_indices).",
    "worlds.<name>.fleets.<name>.action_paths.patrol": "V2.1.0 : liste des waypoints navigables par cette fleet (lane_graph_indices intersect non vide), excluant les waypoints de service (chargers, pickup, dropoff, cleaning_zones). Pour les UI de dispatch patrol.",
    "worlds.<name>.fleets.<name>.action_paths.delivery": "V2.1.0 : sous-set des waypoints navigables avec pickup_dispenser OU dropoff_ingestor, pour les UI de dispatch delivery."
  },
  "audit_lane_pending": false,
  "dispatch_examples": {
    "patrol_hotel": {
      "type": "dispatch_task_request",
      "request": {
        "unix_millis_earliest_start_time": 1779230868000,
        "unix_millis_request_time": 1779230868000,
        "requester": "frontend-svelte",
        "category": "patrol",
        "description": {
          "places": [
            "lobby",
            "shop"
          ],
          "rounds": 1
        }
      }
    },
    "delivery_office": {
      "type": "dispatch_task_request",
      "request": {
        "unix_millis_earliest_start_time": 1779230868000,
        "unix_millis_request_time": 1779230868000,
        "requester": "frontend-svelte",
        "category": "delivery",
        "description": {
          "pickup": {
            "place": "pantry",
            "handler": "coke_dispenser",
            "payload": {
              "sku": "coke",
              "quantity": 1
            }
          },
          "dropoff": {
            "place": "hardware_2",
            "handler": "coke_ingestor",
            "payload": {
              "sku": "coke",
              "quantity": 1
            }
          }
        }
      }
    },
    "clean_hotel_compose": {
      "_comment": "IMPORTANT: clean utilise category=compose (PAS category=clean direct). Cf doc rmf-task-dispatch.md section Description par categorie.",
      "type": "dispatch_task_request",
      "request": {
        "unix_millis_earliest_start_time": 1779230868000,
        "unix_millis_request_time": 1779230868000,
        "requester": "frontend-svelte",
        "category": "compose",
        "description": {
          "category": "clean",
          "phases": [
            {
              "activity": {
                "category": "sequence",
                "description": {
                  "activities": [
                    {
                      "category": "go_to_place",
                      "description": "clean_lobby"
                    },
                    {
                      "category": "perform_action",
                      "description": {
                        "unix_millis_action_duration_estimate": 60000,
                        "category": "clean",
                        "expected_finish_location": "clean_lobby",
                        "description": {
                          "zone": "clean_lobby"
                        },
                        "use_tool_sink": true
                      }
                    }
                  ]
                }
              }
            }
          ]
        }
      }
    }
  },
  "worlds": {
    "hotel": {
      "world": "hotel",
      "waypoints": {
        "lobby": {
          "level": "L1",
          "x": 349.99,
          "y": 530.733,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true
        },
        "shop": {
          "level": "L1",
          "x": 172.189,
          "y": 669.991,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true
        },
        "restaurant": {
          "level": "L1",
          "x": 351.828,
          "y": 283.998,
          "lane_graph_indices": [
            2,
            0
          ],
          "is_holding_point": true
        },
        "kitchen": {
          "level": "L1",
          "x": 351.869,
          "y": 171.799,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true
        },
        "clean_lobby": {
          "level": "L1",
          "x": 428.186,
          "y": 637.526,
          "lane_graph_indices": [
            1
          ],
          "is_cleaning_zone": true
        },
        "clean_waiting_area": {
          "level": "L1",
          "x": 153.759,
          "y": 417.897,
          "lane_graph_indices": [
            1
          ],
          "is_cleaning_zone": true
        },
        "cleanerbot_charger2": {
          "level": "L1",
          "x": 525.131,
          "y": 496.822,
          "lane_graph_indices": [
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "cleanerBotA_2",
          "spawn_robot_type": "Open-RMF/CleanerBotA"
        },
        "cleanerbot_charger1": {
          "level": "L1",
          "x": 473.507,
          "y": 498.428,
          "lane_graph_indices": [
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "cleanerBotA_1",
          "spawn_robot_type": "Open-RMF/CleanerBotA"
        },
        "clean_restaurant": {
          "level": "L1",
          "x": 230.964,
          "y": 204.483,
          "lane_graph_indices": [
            1
          ],
          "is_cleaning_zone": true
        },
        "tinybot_charger": {
          "level": "L1",
          "x": 422.801,
          "y": 492.463,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyBot_1",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "deliverybot_charger": {
          "level": "L1",
          "x": 261.443,
          "y": 700.003,
          "lane_graph_indices": [
            2
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "deliveryBot_1",
          "spawn_robot_type": "Open-RMF/DeliveryRobot"
        },
        "L2_room1": {
          "level": "L2",
          "x": 247.477,
          "y": 96.538,
          "lane_graph_indices": [
            0,
            2
          ]
        },
        "L2_master_suite": {
          "level": "L2",
          "x": 74.568,
          "y": 598.899,
          "lane_graph_indices": [
            0,
            2
          ]
        },
        "L2_room15": {
          "level": "L2",
          "x": 514.769,
          "y": 533.427,
          "lane_graph_indices": [
            0,
            2
          ]
        },
        "L3_room1": {
          "level": "L3",
          "x": 247.477,
          "y": 96.538,
          "lane_graph_indices": [
            0,
            2
          ]
        },
        "L3_master_suite": {
          "level": "L3",
          "x": 74.568,
          "y": 598.899,
          "lane_graph_indices": [
            0,
            2
          ]
        },
        "L3_room15": {
          "level": "L3",
          "x": 514.769,
          "y": 533.427,
          "lane_graph_indices": [
            0,
            2
          ]
        }
      },
      "fleets": {
        "cleanerBotA": {
          "actions": [
            "clean"
          ],
          "task_capabilities": {
            "loop": false,
            "delivery": false
          },
          "finishing_request": "park",
          "recharge_threshold": 0.2,
          "max_delay": 15.0,
          "robots": {
            "cleanerBotA_1": {
              "charger": "cleanerbot_charger1"
            },
            "cleanerBotA_2": {
              "charger": "cleanerbot_charger2"
            }
          },
          "action_paths": {
            "clean": [
              "clean_lobby",
              "clean_restaurant",
              "clean_waiting_area"
            ]
          },
          "lane_graph_indices": [
            1
          ]
        },
        "deliveryRobot": {
          "actions": [],
          "task_capabilities": {
            "loop": true,
            "delivery": true
          },
          "finishing_request": "park",
          "recharge_threshold": 0.1,
          "max_delay": 15.0,
          "robots": {
            "deliveryBot_1": {
              "charger": "deliverybot_charger"
            }
          },
          "lane_graph_indices": [
            2
          ],
          "action_paths": {
            "patrol": [
              "L2_master_suite",
              "L2_room1",
              "L2_room15",
              "L3_master_suite",
              "L3_room1",
              "L3_room15",
              "kitchen",
              "restaurant"
            ]
          }
        },
        "tinyRobot": {
          "actions": [],
          "task_capabilities": {
            "loop": true,
            "delivery": true
          },
          "finishing_request": "park",
          "recharge_threshold": 0.1,
          "max_delay": 15.0,
          "robots": {
            "tinyBot_1": {
              "charger": "tinybot_charger"
            }
          },
          "lane_graph_indices": [
            0
          ],
          "action_paths": {
            "patrol": [
              "L2_master_suite",
              "L2_room1",
              "L2_room15",
              "L3_master_suite",
              "L3_room1",
              "L3_room15",
              "lobby",
              "restaurant",
              "shop"
            ]
          }
        }
      }
    },
    "office": {
      "world": "office",
      "waypoints": {
        "presupplies": {
          "level": "L1",
          "x": 830.922,
          "y": 249.364,
          "lane_graph_indices": [
            0
          ],
          "is_parking_spot": false
        },
        "patrol_D2": {
          "level": "L1",
          "x": 1210.544,
          "y": 365.254,
          "lane_graph_indices": [
            0
          ]
        },
        "patrol_A1": {
          "level": "L1",
          "x": 1191.442,
          "y": 824.457,
          "lane_graph_indices": [
            0
          ]
        },
        "tinyRobot1_charger": {
          "level": "L1",
          "x": 1232.421,
          "y": 658.567,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobot1",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "patrol_D1": {
          "level": "L1",
          "x": 1991.121,
          "y": 812.872,
          "lane_graph_indices": [
            0
          ]
        },
        "pantry": {
          "level": "L1",
          "x": 1990,
          "y": 638.364,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false,
          "pickup_dispenser": "coke_dispenser"
        },
        "lounge": {
          "level": "L1",
          "x": 2438.386,
          "y": 471.243,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "hardware_2": {
          "level": "L1",
          "x": 2474.545,
          "y": 885.636,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false,
          "dropoff_ingestor": "coke_ingestor"
        },
        "coe": {
          "level": "L1",
          "x": 631.562,
          "y": 587.894,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false,
          "dropoff_ingestor": "coke_ingestor_2"
        },
        "patrol_C": {
          "level": "L1",
          "x": 2222.415,
          "y": 1308.722,
          "lane_graph_indices": [
            0
          ]
        },
        "patrol_B": {
          "level": "L1",
          "x": 943.631,
          "y": 1273.435,
          "lane_graph_indices": [
            0
          ]
        },
        "supplies": {
          "level": "L1",
          "x": 770.875,
          "y": 383.434,
          "lane_graph_indices": [
            0
          ],
          "is_parking_spot": true
        },
        "patrol_A2": {
          "level": "L1",
          "x": 2238.471,
          "y": 477.123,
          "lane_graph_indices": [
            0
          ]
        },
        "tinyRobot2_charger": {
          "level": "L1",
          "x": 2412.581,
          "y": 627.5,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobot2",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        }
      },
      "fleets": {
        "tinyRobot": {
          "actions": [
            "teleop"
          ],
          "task_capabilities": {
            "loop": true,
            "delivery": true
          },
          "finishing_request": "charge",
          "recharge_threshold": 0.1,
          "max_delay": null,
          "robots": {
            "tinyRobot1": {
              "charger": "tinyRobot1_charger"
            },
            "tinyRobot2": {
              "charger": "tinyRobot2_charger"
            }
          },
          "lane_graph_indices": [
            0
          ],
          "action_paths": {
            "patrol": [
              "lounge",
              "patrol_A1",
              "patrol_A2",
              "patrol_B",
              "patrol_C",
              "patrol_D1",
              "patrol_D2",
              "presupplies",
              "supplies"
            ],
            "delivery": [
              "coe",
              "hardware_2",
              "pantry"
            ]
          }
        }
      }
    },
    "clinic": {
      "world": "clinic",
      "waypoints": {
        "L1_left_treatment_1": {
          "level": "L1",
          "x": 375.127,
          "y": 505.417,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "L1_sub_waiting_area_1": {
          "level": "L1",
          "x": 297.418,
          "y": 1178.746,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "deliveryRobot_1",
          "spawn_robot_type": "Open-RMF/DeliveryRobot"
        },
        "L1_left_negative_air_pressure": {
          "level": "L1",
          "x": 379.739,
          "y": 997.569,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "L1_sub_waiting_area_2": {
          "level": "L1",
          "x": 566.194,
          "y": 382.071,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "L1_left_nurse_center": {
          "level": "L1",
          "x": 799.486,
          "y": 728.99,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L1_sub_waiting_area_3": {
          "level": "L1",
          "x": 1369.498,
          "y": 372.678,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "L1_right_nurse_center": {
          "level": "L1",
          "x": 1519.393,
          "y": 750.879,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L1_right_procedure": {
          "level": "L1",
          "x": 1943.079,
          "y": 499.601,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "L1_right_treatment": {
          "level": "L1",
          "x": 1914.743,
          "y": 735.042,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "L1_right_negative_air_pressure": {
          "level": "L1",
          "x": 1896.752,
          "y": 1153.905,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "L1_sub_waiting_sucks_6": {
          "level": "L1",
          "x": 1148.814,
          "y": 1249.472,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L1_sub_waiting_area_4": {
          "level": "L1",
          "x": 1150.449,
          "y": 517.735,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L1_sub_waiting_area_5": {
          "level": "L1",
          "x": 1153.569,
          "y": 887.2,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L1_sub_waiting_area_8": {
          "level": "L1",
          "x": 1849.818,
          "y": 1619.119,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L1_sub_waiting_area_7": {
          "level": "L1",
          "x": 1890.779,
          "y": 1284.05,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "deliveryRobot_1_charger": {
          "level": "L1",
          "x": 472.318,
          "y": 1384.18,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "deliveryRobot_2_charger": {
          "level": "L1",
          "x": 476.654,
          "y": 1431.796,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "deliveryRobot_2",
          "spawn_robot_type": "Open-RMF/DeliveryRobot"
        },
        "L2_right_nurse_center": {
          "level": "L2",
          "x": 1507.683,
          "y": 756.646,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_parking_spot": true
        },
        "L2_left_nurse_center": {
          "level": "L2",
          "x": 799.163,
          "y": 735.983,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L2_north_counter": {
          "level": "L2",
          "x": 1117.452,
          "y": 302.496,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L2_west_counter": {
          "level": "L2",
          "x": 307.132,
          "y": 650.842,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L2_sub_waiting_area_1": {
          "level": "L2",
          "x": 301.735,
          "y": 1249.737,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L2_east_counter": {
          "level": "L2",
          "x": 2030.233,
          "y": 1054.39,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L2_south_counter": {
          "level": "L2",
          "x": 1304.19,
          "y": 1511.257,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L2_sub_waiting_area_3": {
          "level": "L2",
          "x": 1152.906,
          "y": 1019.841,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "L2_sub_waiting_area_2": {
          "level": "L2",
          "x": 1151.378,
          "y": 640.927,
          "lane_graph_indices": [
            0,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "tinyRobot_1_charger": {
          "level": "L2",
          "x": 2034.143,
          "y": 401.161,
          "lane_graph_indices": [
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobot_1",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "tinyRobot_2_charger": {
          "level": "L2",
          "x": 2035.112,
          "y": 479.953,
          "lane_graph_indices": [
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobot_2",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "L2_sub_waiting_area_4": {
          "level": "L2",
          "x": 1156.279,
          "y": 1254.687,
          "lane_graph_indices": [
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        }
      },
      "fleets": {
        "deliveryRobot": {
          "actions": [],
          "task_capabilities": {
            "loop": true,
            "delivery": true
          },
          "finishing_request": "park",
          "recharge_threshold": 0.1,
          "max_delay": 15.0,
          "robots": {
            "deliveryRobot_1": {
              "charger": "L1_sub_waiting_area_1"
            },
            "deliveryRobot_2": {
              "charger": "deliveryRobot_2_charger"
            }
          },
          "lane_graph_indices": [
            0
          ],
          "action_paths": {
            "patrol": [
              "L1_left_negative_air_pressure",
              "L1_left_nurse_center",
              "L1_left_treatment_1",
              "L1_right_negative_air_pressure",
              "L1_right_nurse_center",
              "L1_right_procedure",
              "L1_right_treatment",
              "L1_sub_waiting_area_2",
              "L1_sub_waiting_area_3",
              "L1_sub_waiting_area_4",
              "L1_sub_waiting_area_5",
              "L1_sub_waiting_area_7",
              "L1_sub_waiting_area_8",
              "L1_sub_waiting_sucks_6",
              "L2_east_counter",
              "L2_left_nurse_center",
              "L2_north_counter",
              "L2_right_nurse_center",
              "L2_south_counter",
              "L2_sub_waiting_area_1",
              "L2_sub_waiting_area_2",
              "L2_sub_waiting_area_3",
              "L2_west_counter",
              "deliveryRobot_1_charger"
            ]
          }
        },
        "tinyRobot": {
          "actions": [],
          "task_capabilities": {
            "loop": true,
            "delivery": true
          },
          "finishing_request": "park",
          "recharge_threshold": 0.1,
          "max_delay": 15.0,
          "robots": {
            "tinyRobot_1": {
              "charger": "tinyRobot_1_charger"
            },
            "tinyRobot_2": {
              "charger": "tinyRobot_2_charger"
            }
          },
          "lane_graph_indices": [
            1
          ],
          "action_paths": {
            "patrol": [
              "L1_left_nurse_center",
              "L1_right_nurse_center",
              "L1_sub_waiting_area_3",
              "L1_sub_waiting_area_4",
              "L2_east_counter",
              "L2_left_nurse_center",
              "L2_north_counter",
              "L2_right_nurse_center",
              "L2_south_counter",
              "L2_sub_waiting_area_1",
              "L2_sub_waiting_area_2",
              "L2_sub_waiting_area_3",
              "L2_sub_waiting_area_4",
              "L2_west_counter"
            ]
          }
        }
      }
    },
    "airport_terminal": {
      "world": "airport_terminal",
      "waypoints": {
        "junction_n02": {
          "level": "L1",
          "x": 137.72,
          "y": 162.056,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n12": {
          "level": "L1",
          "x": 778.491,
          "y": 131.46,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n18": {
          "level": "L1",
          "x": 1584.996,
          "y": 76.951,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n20": {
          "level": "L1",
          "x": 1821.934,
          "y": 129.564,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n26": {
          "level": "L1",
          "x": 2518.787,
          "y": 84.592,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n28": {
          "level": "L1",
          "x": 2652.887,
          "y": 132.432,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n32": {
          "level": "L1",
          "x": 3203.036,
          "y": 164.688,
          "lane_graph_indices": [
            2
          ]
        },
        "caddy": {
          "level": "L1",
          "x": 3416.064,
          "y": 547.364,
          "lane_graph_indices": [
            2
          ],
          "spawn_robot_name": "caddy",
          "spawn_robot_type": "Open-RMF/Caddy"
        },
        "s20": {
          "level": "L1",
          "x": 2982.626,
          "y": 585.056,
          "lane_graph_indices": [
            2
          ],
          "is_parking_spot": true
        },
        "charger_tinyRobot_3": {
          "level": "L1",
          "x": 3252.106,
          "y": 748.225,
          "lane_graph_indices": [
            2
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "charger_tinyRobot_2": {
          "level": "L1",
          "x": 3227.143,
          "y": 748.225,
          "lane_graph_indices": [
            2
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "charger_tinyRobot_1": {
          "level": "L1",
          "x": 3200.217,
          "y": 748.225,
          "lane_graph_indices": [
            2
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "charger_tinyRobot_0": {
          "level": "L1",
          "x": 3170.206,
          "y": 747.944,
          "lane_graph_indices": [
            2
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "junction_s16": {
          "level": "L1",
          "x": 2604.613,
          "y": 464.703,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_s15": {
          "level": "L1",
          "x": 2550.017,
          "y": 465.422,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_s13": {
          "level": "L1",
          "x": 2355.209,
          "y": 469.536,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_s11": {
          "level": "L1",
          "x": 1841.321,
          "y": 474.949,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_s10": {
          "level": "L1",
          "x": 1525.798,
          "y": 478.893,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_s07": {
          "level": "L1",
          "x": 796.508,
          "y": 443.73,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n10": {
          "level": "L1",
          "x": 672.628,
          "y": 448.714,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n05": {
          "level": "L1",
          "x": 361.405,
          "y": 524.174,
          "lane_graph_indices": [
            2
          ]
        },
        "junction_n01": {
          "level": "L1",
          "x": 19.383,
          "y": 546.11,
          "lane_graph_indices": [
            2,
            1
          ]
        },
        "n03": {
          "level": "L1",
          "x": 265.173,
          "y": 334.272,
          "lane_graph_indices": [
            2
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobot_3",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "charger_deliveryRobot_0": {
          "level": "L1",
          "x": 147.91,
          "y": 21.692,
          "lane_graph_indices": [
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "charger_deliveryRobot_1": {
          "level": "L1",
          "x": 183.306,
          "y": 76.739,
          "lane_graph_indices": [
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "charger_deliveryRobot_2": {
          "level": "L1",
          "x": 179.938,
          "y": 112.994,
          "lane_graph_indices": [
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "deliveryRobot_2",
          "spawn_robot_type": "Open-RMF/DeliveryRobot"
        },
        "junction_n11": {
          "level": "L1",
          "x": 780.329,
          "y": 286.515,
          "lane_graph_indices": [
            2
          ]
        },
        "tinyRobot_n09": {
          "level": "L1",
          "x": 701.934,
          "y": 344.833,
          "lane_graph_indices": [
            2
          ]
        },
        "tinyRobot_n11": {
          "level": "L1",
          "x": 898.29,
          "y": 296.794,
          "lane_graph_indices": [
            2
          ]
        },
        "tinyRobot_n10": {
          "level": "L1",
          "x": 900.34,
          "y": 346.54,
          "lane_graph_indices": [
            2
          ]
        },
        "n12": {
          "level": "L1",
          "x": 852.112,
          "y": 60.245,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n13": {
          "level": "L1",
          "x": 1038.868,
          "y": 59.814,
          "lane_graph_indices": [
            2,
            1
          ],
          "is_parking_spot": true
        },
        "n15_1": {
          "level": "L1",
          "x": 1423.265,
          "y": 172.268,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n15_0": {
          "level": "L1",
          "x": 1384.545,
          "y": 169.4,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n22": {
          "level": "L1",
          "x": 1994.913,
          "y": 166.163,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n25": {
          "level": "L1",
          "x": 2247.093,
          "y": 51.942,
          "lane_graph_indices": [
            2,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n31_0": {
          "level": "L1",
          "x": 3074.724,
          "y": 344.826,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n31_1": {
          "level": "L1",
          "x": 3075.68,
          "y": 374.951,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n01": {
          "level": "L1",
          "x": 14.852,
          "y": 577.209,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "n05": {
          "level": "L1",
          "x": 361.34,
          "y": 467.527,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "west_koi_pond": {
          "level": "L1",
          "x": 417.951,
          "y": 123.318,
          "lane_graph_indices": [
            2,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "n08": {
          "level": "L1",
          "x": 731.789,
          "y": 90.56,
          "lane_graph_indices": [
            2,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n14_0": {
          "level": "L1",
          "x": 1095.018,
          "y": 337.539,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "n14_1": {
          "level": "L1",
          "x": 1116.553,
          "y": 337.331,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": false
        },
        "s08": {
          "level": "L1",
          "x": 1176.243,
          "y": 632.773,
          "lane_graph_indices": [
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "deliveryRobot_0",
          "spawn_robot_type": "Open-RMF/DeliveryRobot"
        },
        "n24_1": {
          "level": "L1",
          "x": 2259.639,
          "y": 343.148,
          "lane_graph_indices": [
            2
          ],
          "is_parking_spot": true
        },
        "n32": {
          "level": "L1",
          "x": 3174.244,
          "y": 68.672,
          "lane_graph_indices": [
            2
          ],
          "is_parking_spot": true
        },
        "east_koi_pond": {
          "level": "L1",
          "x": 2625.104,
          "y": 59.568,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n28": {
          "level": "L1",
          "x": 2736.946,
          "y": 230.306,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n33": {
          "level": "L1",
          "x": 3412.49,
          "y": 397.058,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "s10": {
          "level": "L1",
          "x": 1498.749,
          "y": 556.073,
          "lane_graph_indices": [
            2,
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "s11": {
          "level": "L1",
          "x": 1855.142,
          "y": 539.669,
          "lane_graph_indices": [
            2,
            1
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "deliveryRobot_1",
          "spawn_robot_type": "Open-RMF/DeliveryRobot"
        },
        "s15_1": {
          "level": "L1",
          "x": 2523.327,
          "y": 467.79,
          "lane_graph_indices": [
            2
          ],
          "is_parking_spot": true
        },
        "s15_0": {
          "level": "L1",
          "x": 2537.997,
          "y": 589.59,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n29": {
          "level": "L1",
          "x": 2830.697,
          "y": 443.595,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "s23": {
          "level": "L1",
          "x": 3281.662,
          "y": 636.129,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "junction_north_west": {
          "level": "L1",
          "x": 895.192,
          "y": 119.589,
          "lane_graph_indices": [
            1
          ]
        },
        "deliveryRobot_n10": {
          "level": "L1",
          "x": 899.111,
          "y": 343.99,
          "lane_graph_indices": [
            1
          ]
        },
        "junction_south_west": {
          "level": "L1",
          "x": 1029.672,
          "y": 460.428,
          "lane_graph_indices": [
            1
          ]
        },
        "junction_central_west": {
          "level": "L1",
          "x": 1538.448,
          "y": 480.253,
          "lane_graph_indices": [
            1
          ]
        },
        "junction_central_east": {
          "level": "L1",
          "x": 1828.635,
          "y": 475.911,
          "lane_graph_indices": [
            1
          ]
        },
        "junction_south_east": {
          "level": "L1",
          "x": 2397.829,
          "y": 469.071,
          "lane_graph_indices": [
            1
          ]
        },
        "junction_north_east": {
          "level": "L1",
          "x": 2517.377,
          "y": 83.887,
          "lane_graph_indices": [
            1
          ]
        },
        "n15": {
          "level": "L1",
          "x": 1361.185,
          "y": 132.291,
          "lane_graph_indices": [
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n20": {
          "level": "L1",
          "x": 1720.979,
          "y": 55.019,
          "lane_graph_indices": [
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n24": {
          "level": "L1",
          "x": 2416.178,
          "y": 325.307,
          "lane_graph_indices": [
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n23": {
          "level": "L1",
          "x": 2233.697,
          "y": 508.932,
          "lane_graph_indices": [
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "n14": {
          "level": "L1",
          "x": 972.431,
          "y": 347.198,
          "lane_graph_indices": [
            1
          ],
          "is_holding_point": true,
          "is_parking_spot": true
        },
        "tinyRobot_s07": {
          "level": "L1",
          "x": 840.744,
          "y": 474.762,
          "lane_graph_indices": [
            2
          ]
        },
        "s06": {
          "level": "L1",
          "x": 601.608,
          "y": 466.31,
          "lane_graph_indices": [
            2
          ]
        },
        "koi_pond": {
          "level": "L1",
          "x": 673.858,
          "y": 72.735,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true
        },
        "s03": {
          "level": "L1",
          "x": 349.72,
          "y": 623.377,
          "lane_graph_indices": [
            2
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobot_0",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "s07": {
          "level": "L1",
          "x": 827.637,
          "y": 601.074,
          "lane_graph_indices": [
            2
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobot_1",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "spill": {
          "level": "L1",
          "x": 321.478,
          "y": 577.193,
          "lane_graph_indices": [
            2
          ],
          "is_holding_point": true,
          "is_parking_spot": false,
          "dropoff_ingestor": "mopcart_collector"
        },
        "mopcart_pickup": {
          "level": "L1",
          "x": 270.109,
          "y": 443.861,
          "lane_graph_indices": [
            2
          ],
          "is_parking_spot": false,
          "pickup_dispenser": "mopcart_dispenser"
        },
        "zone_1": {
          "level": "L1",
          "x": 1477.21,
          "y": 344.67,
          "lane_graph_indices": [
            0
          ],
          "is_cleaning_zone": true
        },
        "zone_3": {
          "level": "L1",
          "x": 1880.59,
          "y": 335.992,
          "lane_graph_indices": [
            0,
            4
          ],
          "is_cleaning_zone": true
        },
        "zone_2": {
          "level": "L1",
          "x": 1813.842,
          "y": 330.119,
          "lane_graph_indices": [
            0,
            4
          ],
          "is_cleaning_zone": true
        },
        "charger_cleanerBotE_0": {
          "level": "L1",
          "x": 1944.653,
          "y": 676.57,
          "lane_graph_indices": [
            4
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "cleanerBotE_0",
          "spawn_robot_type": "Open-RMF/CleanerBotE"
        },
        "charger_cleanerBotE_1": {
          "level": "L1",
          "x": 1990.009,
          "y": 677.358,
          "lane_graph_indices": [
            4
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "cleanerBotE_1",
          "spawn_robot_type": "Open-RMF/CleanerBotE"
        },
        "zone_4": {
          "level": "L1",
          "x": 1850.375,
          "y": 734.322,
          "lane_graph_indices": [
            0,
            4
          ],
          "is_cleaning_zone": true
        },
        "charger_cleanerBotA_0": {
          "level": "L1",
          "x": 1429.736,
          "y": 602.524,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "cleanerBotA_0",
          "spawn_robot_type": "Open-RMF/CleanerBotA"
        }
      },
      "fleets": {
        "cleanerBotA": {
          "actions": [
            "clean"
          ],
          "task_capabilities": {
            "loop": false,
            "delivery": false
          },
          "finishing_request": "park",
          "recharge_threshold": 0.2,
          "max_delay": 15.0,
          "robots": {
            "cleanerBotA_0": {
              "charger": "charger_cleanerBotA_0"
            }
          },
          "action_paths": {
            "clean": [
              "zone_1",
              "zone_2",
              "zone_3",
              "zone_4"
            ]
          },
          "lane_graph_indices": [
            0
          ]
        },
        "cleanerBotE": {
          "actions": [
            "clean"
          ],
          "task_capabilities": {
            "loop": false,
            "delivery": false
          },
          "finishing_request": "park",
          "recharge_threshold": 0.2,
          "max_delay": 15.0,
          "robots": {
            "cleanerBotE_0": {
              "charger": "charger_cleanerBotE_0"
            },
            "cleanerBotE_1": {
              "charger": "charger_cleanerBotE_1"
            }
          },
          "action_paths": {
            "clean": [
              "zone_2",
              "zone_3",
              "zone_4"
            ]
          },
          "lane_graph_indices": [
            4
          ]
        },
        "deliveryRobot": {
          "actions": [],
          "task_capabilities": {
            "loop": true,
            "delivery": true
          },
          "finishing_request": "park",
          "recharge_threshold": 0.1,
          "max_delay": 15.0,
          "robots": {
            "deliveryRobot_0": {
              "charger": "s08"
            },
            "deliveryRobot_1": {
              "charger": "s11"
            },
            "deliveryRobot_2": {
              "charger": "charger_deliveryRobot_2"
            }
          },
          "lane_graph_indices": [
            1,
            2
          ],
          "action_paths": {
            "patrol": [
              "caddy",
              "deliveryRobot_n10",
              "east_koi_pond",
              "junction_central_east",
              "junction_central_west",
              "junction_n01",
              "junction_n02",
              "junction_n05",
              "junction_n10",
              "junction_n11",
              "junction_n12",
              "junction_n18",
              "junction_n20",
              "junction_n26",
              "junction_n28",
              "junction_n32",
              "junction_north_east",
              "junction_north_west",
              "junction_s07",
              "junction_s10",
              "junction_s11",
              "junction_s13",
              "junction_s15",
              "junction_s16",
              "junction_south_east",
              "junction_south_west",
              "koi_pond",
              "n01",
              "n05",
              "n08",
              "n12",
              "n13",
              "n14",
              "n14_0",
              "n14_1",
              "n15",
              "n15_0",
              "n15_1",
              "n20",
              "n22",
              "n23",
              "n24",
              "n24_1",
              "n25",
              "n28",
              "n29",
              "n31_0",
              "n31_1",
              "n32",
              "n33",
              "s06",
              "s10",
              "s15_0",
              "s15_1",
              "s20",
              "s23",
              "tinyRobot_n09",
              "tinyRobot_n10",
              "tinyRobot_n11",
              "tinyRobot_s07",
              "west_koi_pond"
            ],
            "delivery": [
              "mopcart_pickup",
              "spill"
            ]
          }
        },
        "tinyRobot": {
          "actions": [],
          "task_capabilities": {
            "loop": true,
            "delivery": true
          },
          "finishing_request": "park",
          "recharge_threshold": 0.1,
          "max_delay": 15.0,
          "robots": {
            "tinyRobot_0": {
              "charger": "s03"
            },
            "tinyRobot_1": {
              "charger": "s07"
            },
            "tinyRobot_2": {
              "charger": "n13"
            },
            "tinyRobot_3": {
              "charger": "n03"
            }
          },
          "lane_graph_indices": [
            1,
            2
          ],
          "action_paths": {
            "patrol": [
              "caddy",
              "deliveryRobot_n10",
              "east_koi_pond",
              "junction_central_east",
              "junction_central_west",
              "junction_n01",
              "junction_n02",
              "junction_n05",
              "junction_n10",
              "junction_n11",
              "junction_n12",
              "junction_n18",
              "junction_n20",
              "junction_n26",
              "junction_n28",
              "junction_n32",
              "junction_north_east",
              "junction_north_west",
              "junction_s07",
              "junction_s10",
              "junction_s11",
              "junction_s13",
              "junction_s15",
              "junction_s16",
              "junction_south_east",
              "junction_south_west",
              "koi_pond",
              "n01",
              "n05",
              "n08",
              "n12",
              "n13",
              "n14",
              "n14_0",
              "n14_1",
              "n15",
              "n15_0",
              "n15_1",
              "n20",
              "n22",
              "n23",
              "n24",
              "n24_1",
              "n25",
              "n28",
              "n29",
              "n31_0",
              "n31_1",
              "n32",
              "n33",
              "s06",
              "s10",
              "s15_0",
              "s15_1",
              "s20",
              "s23",
              "tinyRobot_n09",
              "tinyRobot_n10",
              "tinyRobot_n11",
              "tinyRobot_s07",
              "west_koi_pond"
            ],
            "delivery": [
              "mopcart_pickup",
              "spill"
            ]
          }
        }
      }
    },
    "battle_royale": {
      "world": "battle_royale",
      "waypoints": {
        "goal_D": {
          "level": "L1",
          "x": 393.316,
          "y": 108.388,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true
        },
        "start_C": {
          "level": "L1",
          "x": 323.69,
          "y": 38.789,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobotC",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "goal_B": {
          "level": "L1",
          "x": 393.181,
          "y": 323.936,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true
        },
        "goal_A": {
          "level": "L1",
          "x": 323.572,
          "y": 393.261,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true
        },
        "start_D": {
          "level": "L1",
          "x": 38.707,
          "y": 323.948,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobotD",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "goal_C": {
          "level": "L1",
          "x": 108.352,
          "y": 393.269,
          "lane_graph_indices": [
            0
          ],
          "is_holding_point": true
        },
        "start_A": {
          "level": "L1",
          "x": 108.296,
          "y": 38.977,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobotA",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        },
        "start_B": {
          "level": "L1",
          "x": 38.887,
          "y": 108.285,
          "lane_graph_indices": [
            0
          ],
          "is_charger": true,
          "is_holding_point": true,
          "is_parking_spot": true,
          "spawn_robot_name": "tinyRobotB",
          "spawn_robot_type": "Open-RMF/TinyRobot"
        }
      },
      "fleets": {
        "tinyRobot": {
          "actions": [],
          "task_capabilities": {
            "loop": true,
            "delivery": true
          },
          "finishing_request": "nothing",
          "recharge_threshold": 0.1,
          "max_delay": 15.0,
          "robots": {
            "tinyRobotA": {
              "charger": "start_A"
            },
            "tinyRobotB": {
              "charger": "start_B"
            },
            "tinyRobotC": {
              "charger": "start_C"
            },
            "tinyRobotD": {
              "charger": "start_D"
            }
          },
          "lane_graph_indices": [
            0
          ],
          "action_paths": {
            "patrol": [
              "goal_A",
              "goal_B",
              "goal_C",
              "goal_D"
            ]
          }
        }
      }
    }
  }
}
